import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
const listStyles = css({
  paddingLeft: "var(--ds-space-250, 20px)",
  paddingInlineStart: "var(--ds-space-250, 20px)"
});
const UList = ({
  children,
  ...props
}) => jsx("ul", _extends({
  css: listStyles
}, props), children);
export default UList;